/**
 * Transforms dynamic fields from the current format to the other project's format
 * @param {Array} dynamicAnswers - Current format: [{field, values, meta}]
 * @returns {Array} - Other project format: [{key, value, meta}]
 */
export const transformDynamicFieldsFormat = (dynamicAnswers) => {
    return dynamicAnswers.map(field => {
        const { field: fieldName, values, meta } = field;
        
        // Handle different field types
        if (meta.type === 'multiple-dropdown') {
            // For multiple dropdown, join values with pipe separator
            return {
                key: meta.label,
                value: values.join('|'),
                meta: {
                    ...meta,
                    value: values // Keep original array in meta
                }
            };
        } else {
            // For single value fields, use the first value
            return {
                key: meta.label,
                value: values[0] || '',
                meta: {
                    ...meta,
                    value: values[0] || ''
                }
            };
        }
    });
};

/**
 * Transforms dynamic fields back from other project's format to current format
 * @param {Array} transformedFields - Other project format: [{key, value, meta}]
 * @returns {Array} - Current format: [{field, values, meta}]
 */
export const transformDynamicFieldsFormatBack = (transformedFields) => {
    return transformedFields.map(field => {
        const { key, value, meta } = field;
        
        // Handle different field types
        if (meta.type === 'multiple-dropdown') {
            // For multiple dropdown, split pipe-separated values
            const values = typeof value === 'string' ? value.split('|').filter(v => v.trim()) : [];
            return {
                field: meta.name,
                values: values,
                meta: meta
            };
        } else {
            // For single value fields, wrap in array
            return {
                field: meta.name,
                values: [value],
                meta: meta
            };
        }
    });
};
